/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './service';
import './common';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "buyer": {
        "nested": {
          "rewards": {
            "nested": {
              "RewardsService": {
                "methods": {
                  "GetActiveBalancesV2": {
                    "requestType": ".squareup.rewards.GetActiveBalancesV2Request",
                    "responseType": ".squareup.rewards.GetActiveBalancesV2Response"
                  },
                  "SendReferral": {
                    "requestType": ".squareup.rewards.SendReferralRequest",
                    "responseType": ".squareup.rewards.SendReferralResponse"
                  },
                  "GetReferralStatuses": {
                    "requestType": ".squareup.rewards.GetReferralStatusesRequest",
                    "responseType": ".squareup.rewards.GetReferralStatusesResponse"
                  },
                  "NudgeReferral": {
                    "requestType": ".squareup.rewards.NudgeReferralRequest",
                    "responseType": ".squareup.rewards.StatusResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.buyer?.nested?.rewards?.nested?.RewardsService) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE RewardsService @ squareup/rewards/buyer_service.proto at 12:1
 */
export const RewardsService = $root.lookupService('squareup.buyer.rewards.RewardsService');
